import { Flex, Layout } from '@modusign/design-system';
import { ReactNode } from 'react';

import GlobalLoadingSpinner from '@app/components/Loading/GlobalLoadingSpinner';

import InPersonPageErrorCard from '../InPersonPageErrorCard';
import InPersonPageHeader from '../InPersonPageHeader';

interface InPersonPageLayoutProps {
  children: ReactNode;
  showError?: boolean;
  isLoading: boolean;
  onRetryClick?: () => void;
}

export default function InPersonPageLayout({
  children,
  showError,
  isLoading,
  onRetryClick,
}: InPersonPageLayoutProps) {
  const content = showError ? <InPersonPageErrorCard onRetryClick={onRetryClick} /> : children;
  return (
    // TODO : (JuYeong-Byeon) ds에 bodyNeutralDark lightGray50로 토큰 추가후 제거
    <Flex
      alignItems="center"
      bg="lightGray50"
      flexDirection="column"
      height="100%"
      overflowY="auto"
      width="100%"
    >
      <InPersonPageHeader />
      <Layout flexDirection="column" maxWidth="md" p={4} width="100%">
        {isLoading ? <GlobalLoadingSpinner /> : content}
      </Layout>
    </Flex>
  );
}
